import React from 'react'
import Pt from 'prop-types'
import { Col, Row } from 'react-bootstrap'

import { SignupWithExternalsRecord } from 'internal-components/src/records'
import DetailTable from '../SignupDetails/DetailTable'

export default function Completed({ signupWithExternals }) {
  return (
    <div className="signup-completed">
      <Row>
        <Col md={12}>
          <h3>Success!</h3>
          <h4>A new signup has been created and forwarded to the Client.</h4>

          <p>
            We have notified the Customer that you have created a partially
            completed signup and that they will need to complete the signup to
            submit it.
          </p>
        </Col>
      </Row>

      <Row>
        <Col md={12}>
          <DetailTable signupWithExternals={signupWithExternals} />
        </Col>
      </Row>
    </div>
  )
}

Completed.propTypes = {
  signupWithExternals: Pt.instanceOf(SignupWithExternalsRecord).isRequired,
}



// WEBPACK FOOTER //
// ./src/components/Signup/MspCompleted.jsx